export const HTMLtasks = [
  {
    id: 'html-footer',
    categoryId: '1',
    title: '<footer>',
    code: `<article>
  <h1>How to be a wizard</h1>
  <ol>
    <li>Grow a long, majestic beard.</li>
    <li>Wear a tall, pointed hat.</li>
    <li>Have I mentioned the beard?</li>
  </ol>
  <footer>
    <p>2018 Gandalf</p>
  </footer>
</article>`,
    lang: 'html',
  },
  {
    id: 'html-table',
    categoryId: '1',
    title: '<table>',
    code: `<table>
  <tr>
    <th colspan="2">Languages and Frameworks</th>
  </tr>
  <tr>
    <td>Python</td>
    <td>Django</td>
  </tr>
  <tr>
    <td>JavaScript</td>
    <td>React.js</td>
  </tr>
</table>`,
    lang: 'html',
  },
  {
    id: 'html-article',
    categoryId: '1',
    title: '<article>',
    code: `<article class="forecast">
  <h1>Weather forecast for Seattle</h1>
  <article class="day-forecast">
    <h2>03 March 2018</h2>
    <p>Rain.</p>
  </article>
  <article class="day-forecast">
    <h2>04 March 2018</h2>
    <p>Periods of rain.</p>
  </article>
</article>`,
    lang: 'html',
  },
  {
    id: 'html-details',
    categoryId: '1',
    title: '<details>',
    code: `<details open>
  <summary>System Requirements</summary>
  <p>
    Requires a computer running an operating system. The computer must have some
    memory and ideally some kind of long-term storage.
  </p>
</details>`,
    lang: 'html',
  },
  {
    id: 'html-figcaption',
    categoryId: '1',
    title: '<figcaption>',
    code: `<figure>
  <img src="/media/cc0-images/elephant-660-480.jpg"
    alt="Elephant at sunset">
  <figcaption>An elephant at sunset</figcaption>
</figure>`,
    lang: 'html',
  },
  {
    id: 'html-mark',
    categoryId: '1',
    title: '<mark>',
    code: `<p>Search results for "salamander":</p>

<hr>

<p>Several species of <mark>salamander</mark> inhabit the temperate rainforest of the Pacific Northwest.</p>

<p>Most <mark>salamander</mark>s are nocturnal, and hunt for insects, worms, and other small creatures.</p>`,
    lang: 'html',
  },
  {
    id: 'html-ul',
    categoryId: '1',
    title: '<ul>',
    code: `<p>Apollo astronauts:</p>

<ul>
  <li>Neil Armstrong</li>
  <li>Alan Bean</li>
  <li>Peter Conrad</li>
  <li>Edgar Mitchell</li>
  <li>Alan Shepard</li>
</ul>`,
    lang: 'html',
  },
  {
    id: 'html-nav',
    categoryId: '1',
    title: '<nav>',
    code: `<nav class="crumbs">
  <ol>
    <li class="crumb">
      <a href="#">Bikes</a>
    </li>
    <li class="crumb">
      <a href="#">BMX</a>
    </li>
    <li class="crumb">Jump Bike 3000</li>
  </ol>
</nav>`,
    lang: 'html',
  },
  {
    id: 'html-form',
    categoryId: '1',
    title: '<form>',
    code: `<form method="post">
  <fieldset>
    <legend>Do you agree to the terms?</legend>
    <label><input type="radio" name="radio" value="yes" /> Yes</label>
    <label><input type="radio" name="radio" value="no" /> No</label>
  </fieldset>
</form>`,
    lang: 'html',
  },
  {
    id: 'html-time',
    categoryId: '1',
    title: '<time>',
    code: `<p>The Cure will be celebrating their 40th anniversary on <time datetime="2018-07-07">July 7</time> in London's Hyde Park.</p>

<p>The concert starts at <time datetime="20:00">20:00</time> and you'll be able to enjoy the band for at least <time datetime="PT2H30M">2h 30m</time>.</p>`,
    lang: 'html',
  },
  {
    id: 'html-picture',
    categoryId: '1',
    title: '<picture>',
    code: `<picture>
  <source media="(min-width: 1200px)" srcset="img/photo-desktop.jpg">
  <source media="(min-width: 768px)" srcset="img/photo-tablet.jpg">
  <img src="img/photo-1-mobile.jpg" srcset="img/photo-mobile.jpg" alt="cat">
</picture>`,
    lang: 'html',
  },
]
